import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { groupByMonth } from '@jumbo/utils/formatHelpers';
import { redColor } from 'app/themes/main/default';

function ReportUnitCountTable({ data, showWithDates }) {

  const groupedData = groupByMonth(data);

  return (
    <>
      {Object.keys(groupedData).map((monthName) => (
        <div key={monthName}>
          <h4 style={{
            fontWeight: 'bold',
            marginTop: 20,
            marginBottom: 10,
            color: redColor,
            borderBottom: `2px solid ${redColor}`,
            paddingBottom: 5
          }}>
            {monthName}
          </h4>
          <Table size="small"
            sx={{ marginBottom: 3, marginTop: 1, borderRadius: 3, lineHeight: 1 }}>
            <TableHead sx={{ backgroundColor: "lightgrey" }}>
              <TableRow>
                <TableCell align="left" sx={{  }}>Kurum</TableCell>
                <TableCell align="left" sx={{  }}>Kurul/Kol/Komisyon Adı</TableCell>
                {showWithDates && (
                  <TableCell align="left" sx={{  }}>Tarihler</TableCell>
                )}
                <TableCell align="left" sx={{  }}>Toplantı Sayısı</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groupedData[monthName].map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="left" sx={{  }}>{item.inst}</TableCell>
                  <TableCell align="left" sx={{  }}>{item.unitName}</TableCell>
                  {showWithDates && (
                    <TableCell align="left" sx={{  }}>{item.meetingDates || '-'}</TableCell>
                  )}
                  <TableCell align="left" sx={{  }}>{item.meetingCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </>
  );
}

export default ReportUnitCountTable;